import React from "react";

import { Link } from "gatsby";
import marked from "marked";
import slugify from 'slugify';

import ContributorByline from "../contributors/contributor-byline";
import ThumbnailImage from "../common/thumbnail-image";
import TopicLinks from "../common/topic-links";

class EssayGridCell extends React.Component {
  constructor(props) {
    super(props);

    this.formattedSummary = this.formattedSummary.bind(this);


  }

  formattedSummary() {
    let formattedText = '';

    if (this.props.summary) {
      formattedText = marked(this.props.summary);
      formattedText = formattedText.replace('<p>', '');
      formattedText = formattedText.replace('</p>', '');
    }

    return formattedText;
  }

  render() {
    const date = new Date(this.props.publishedDate);
    const utcDate = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    
    const day = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(utcDate);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(utcDate);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(utcDate);
    
    const dateline = `${day} ${month} ${year}`;
    
    return (
      <div className="essay-grid__cell">
        <div className="details">
          {this.props.featuredImagePath ? (
            <Link to={`/essay/${this.props.slug}`}>
              <ThumbnailImage
                imagePath={this.props.featuredImagePath}
                alt={this.props.title}
                width={600}
              />
            </Link>
          ) : null}
          <p className="title">
            <Link
              to={`/essay/${this.props.slug}`}
              dangerouslySetInnerHTML={{ __html: marked(this.props.title).replace('<p>', '').replace('</p>', '')}}
            />
          </p>
          {(this.props.contributors) ? (
            <p className="byline">
              <ContributorByline contributors={this.props.contributors} />
            </p>
          ) : null}
          {( !this.props.suppressSummary ) ? (
            <p className="summary">
              <span
                dangerouslySetInnerHTML={{__html: this.formattedSummary()}} />
              <Link to={`/essay/${this.props.slug}`} className="read-more">more</Link>
            </p>
          ) : null}
        </div>
        <div className="meta-bar">
          {(this.props.series) ? (
            <div className="series-tag">
              <Link to={`/series/${slugify(this.props.series.toLowerCase())}`}>{this.props.series}</Link>
              <div className="underlay"></div>
            </div>
          ) : null}
          <div className="bottom-bar">
            <div>
            <TopicLinks categories={this.props.categories} />
            </div>
            <div
              className="dateline"
              dangerouslySetInnerHTML={{ __html: dateline }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EssayGridCell;